/**
 * Tailwind class maps for design-system/design-system.html (Portal DS v1.0).
 * Use these via Portal DS components — do not import into legacy pages directly.
 */
export const portalDs = {
  page: 'flex flex-col gap-6 bg-[#F4F5F8]',

  card:
    'rounded-xl border border-[#EDEEF2] bg-white shadow-[0_1px_2px_rgba(13,15,26,0.05)]',

  cardPadding: 'p-5 sm:p-6',

  sectionLabel:
    'text-[11px] font-bold uppercase tracking-[1px] text-[#9CA3AF]',

  sectionTitle:
    'text-xl font-bold tracking-[-0.5px] text-[#0D0F1A]',

  sectionSubtitle:
    'text-[13.5px] leading-relaxed text-[#5E6278]',

  headingH3:
    'text-base font-semibold tracking-[-0.2px] text-[#0D0F1A]',

  bodySm: 'text-[13px] leading-relaxed text-[#5E6278]',

  caption: 'text-[11px] font-medium tracking-[0.3px] text-[#9CA3AF]',

  link:
    'text-[13px] font-medium text-[#2563EB] transition-colors hover:text-[#1D4ED8] hover:underline disabled:opacity-50',

  btnBase:
    'inline-flex items-center justify-center gap-1.5 rounded-lg border-[1.5px] font-semibold tracking-[-0.1px] transition-all focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(37,99,235,0.20)] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-45',

  btnSm: 'px-3 py-1.5 text-xs rounded',

  btnMd: 'px-4 py-[9px] text-[13.5px]',

  btnPrimary:
    'border-[#0D0F1A] bg-[#0D0F1A] text-white hover:border-[#252840] hover:bg-[#252840]',

  btnAccent:
    'border-[#2563EB] bg-[#2563EB] text-white hover:border-[#1D4ED8] hover:bg-[#1D4ED8]',

  btnSecondary:
    'border-[#D9DBE3] bg-white text-[#0D0F1A] hover:border-[#B8BBCA] hover:bg-[#F0F1F5]',

  btnGhost:
    'border-transparent bg-transparent text-[#5E6278] hover:bg-[#F0F1F5] hover:text-[#0D0F1A]',

  field: 'flex flex-col gap-1.5',

  label: 'text-xs font-semibold tracking-[0.1px] text-[#0D0F1A]',

  filterLabel: 'text-[11px] font-bold uppercase tracking-[0.5px] text-[#9CA3AF]',

  hint: 'text-xs text-[#5E6278]',

  input:
    'h-9 w-full rounded-lg border-[1.5px] border-[#D9DBE3] bg-white px-3 text-[13.5px] leading-snug text-[#0D0F1A] outline-none transition-[border-color,box-shadow] placeholder:text-[#9CA3AF] hover:border-[#B8BBCA] focus:border-[#2563EB] focus:shadow-[0_0_0_3px_rgba(37,99,235,0.12)] disabled:cursor-not-allowed disabled:bg-[#F7F8FA] disabled:text-[#9CA3AF]',

  select:
    'h-9 w-full appearance-none rounded-lg border-[1.5px] border-[#D9DBE3] bg-white bg-[length:12px] bg-[right_10px_center] bg-no-repeat px-3 pr-8 text-[13.5px] text-[#0D0F1A] outline-none transition-[border-color,box-shadow] hover:border-[#B8BBCA] focus:border-[#2563EB] focus:shadow-[0_0_0_3px_rgba(37,99,235,0.12)] disabled:cursor-not-allowed disabled:bg-[#F7F8FA] disabled:text-[#9CA3AF] [background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%239CA3AF%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E")]',

  tableContainer:
    'w-full overflow-x-auto rounded-xl border border-[#EDEEF2] bg-white',

  tableHead:
    'bg-[#F7F8FA] border-b-[1.5px] border-[#EDEEF2]',

  tableHeadCell:
    'px-4 py-2.5 text-left text-[11px] font-bold uppercase tracking-[0.5px] text-[#9CA3AF] whitespace-nowrap',

  tableHeadCellSortable:
    'cursor-pointer select-none transition-colors hover:text-[#5E6278]',

  tableBodyRow:
    'border-b border-[#EDEEF2] transition-colors last:border-b-0 hover:bg-[#F0F1F5]',

  tableBodyRowInteractive: 'cursor-pointer focus-visible:bg-[#F0F1F5]',

  tableCell: 'px-4 py-3 text-[13.5px] text-[#0D0F1A] align-middle',

  tableCellMuted: 'text-[#5E6278]',

  tableCellMono: 'font-mono text-[13px]',

  alertBase: 'flex items-start gap-3 rounded-lg border px-5 py-4 text-[13.5px]',

  alertInfo: 'border-[#BFDBFE] bg-[#EFF6FF] text-[#2563EB]',
  alertSuccess: 'border-[#A7F3D0] bg-[#ECFDF5] text-[#059669]',
  alertWarning: 'border-[#FDE68A] bg-[#FFFBEB] text-[#D97706]',
  alertDanger: 'border-[#FECACA] bg-[#FEF2F2] text-[#DC2626]',

  alertTitle: 'text-[13.5px] font-bold',
  alertBody: 'text-[13px] opacity-85',

  noticeBar:
    'flex items-center gap-3 rounded-lg border border-[#FDE68A] bg-[#FFFBEB] px-5 py-2.5 text-[13px] font-medium text-[#D97706]',

  badgeBase:
    'inline-flex items-center gap-1 rounded px-2 py-0.5 text-[11px] font-bold tracking-[0.2px]',

  badgeBlue: 'bg-[#EFF6FF] text-[#2563EB]',
  badgeGreen: 'bg-[#ECFDF5] text-[#059669]',
  badgeAmber: 'bg-[#FFFBEB] text-[#D97706]',
  badgeRed: 'bg-[#FEF2F2] text-[#DC2626]',
  badgeGray: 'bg-[#EDEEF2] text-[#5E6278]',

  statusPill:
    'inline-flex items-center gap-1.5 rounded-full border-[1.5px] px-3 py-1 text-xs font-semibold capitalize',

  statusPillInfo: 'border-[#BFDBFE] bg-[#EFF6FF] text-[#2563EB]',
  statusPillSuccess: 'border-[#A7F3D0] bg-[#ECFDF5] text-[#059669]',
  statusPillWarning: 'border-[#FDE68A] bg-[#FFFBEB] text-[#D97706]',
  statusPillDanger: 'border-[#FECACA] bg-[#FEF2F2] text-[#DC2626]',
  statusPillGray: 'border-[#D9DBE3] bg-[#EDEEF2] text-[#5E6278]',

  formPanel: 'rounded-lg border border-[#EDEEF2] bg-[#F7F8FA] p-5',

  sheetHeader: 'border-b border-[#EDEEF2] px-6 py-5',
  sheetTitle: 'text-xl font-bold tracking-[-0.5px] text-[#0D0F1A]',
  sheetDescription: 'text-[13px] text-[#5E6278]',
  sheetSection: 'border-t border-[#EDEEF2] pt-6',
  sheetSectionTitle: 'text-sm font-semibold text-[#0D0F1A]',

  healthStrip:
    'flex h-16 items-end gap-1 rounded-xl border border-[#EDEEF2] bg-[#F7F8FA] p-3',

  rowCount: 'text-[11px] font-medium tracking-[0.3px] text-[#9CA3AF]',
} as const;
